class ProgressBar extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const { value, animate } = this.props;

    if (value == null) return null;

    const width = value * 100 / 1000;
    const minWidth = value == 0 && "0px" || value == 1 && "2px" || "4px";

    return (
      <div className="flex items-center">
        <div className="w-12 text-center pr-2">
          {!animate && (value)}
        </div>
        <div className="bg-gradient-to-r from-warning-mid via-warning to-danger rounded overflow-hidden h-5 w-full relative flex items-center">
          { value == 0 && !animate && (<span className="font-semibold leading-none px-1 pt-px">BINGO !</span>) }
          <div className={`h-full absolute top-0 right-0 ${animate ? 'animate-reveal' : ''}`} style={{ width: `${width}%`, minWidth: minWidth, maxWidth: "calc(100% - 2px)" }}>
            <div className="h-full bg-grey w-full"></div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProgressBar;
